export default __webpack_public_path__ + "static/media/MOC.457d3e4d.png";